document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-bokja-collection-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    const status = document.getElementById(button.dataset.statusId);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = button.dataset.loading;
    // The shared helper emits cart:update even on rejection. Keep this card's
    // error visible on the page instead of opening an unchanged cart over it.
    const keepErrorOnPage = (update) => {
      if (update.detail?.data?.didError) update.stopPropagation();
    };
    button.addEventListener('cart:update', keepErrorOnPage);
    try {
      if (typeof window.BokjaCartAdd !== 'function') throw new Error('Cart is not ready');
      const result = await window.BokjaCartAdd(button.dataset.variantId, button);
      if (status) status.textContent = result.ok ? button.dataset.added : button.dataset.error;
    } catch {
      if (status) status.textContent = button.dataset.error;
    } finally {
      button.removeEventListener('cart:update', keepErrorOnPage);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

// Collection cards (story groups, category groups): the card box includes the caption, so the plus is placed at
// the PHOTO's bottom edge by measurement, re-measured when the photo resizes (James 2026-09-23).
(() => {
  const MEDIA = '.bokja-storygroup__media, .bokja-catgroup__media';
  const place = (button) => {
    const card = button.parentElement;
    const media = card && card.querySelector(MEDIA);
    if (!media) return;
    const c = card.getBoundingClientRect();
    const m = media.getBoundingClientRect();
    button.style.top = Math.round(m.bottom - c.top - button.offsetHeight) + 'px';
    button.style.bottom = 'auto';
  };
  const setup = () => {
    const buttons = document.querySelectorAll('[data-bokja-qa-measure]');
    buttons.forEach(place);
    if (!window.ResizeObserver) return;
    const ro = new ResizeObserver((entries) => entries.forEach((e) => {
      const b = e.target.closest('.bokja-storygroup__item, .bokja-catgroup__item')?.querySelector('[data-bokja-qa-measure]');
      if (b) place(b);
    }));
    buttons.forEach((b) => { const m = b.parentElement?.querySelector(MEDIA); if (m) ro.observe(m); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
